import { render } from "./searchbar.vue?vue&type=template&id=78bfd48e&scoped=true"
import script from "./searchbar.vue?vue&type=script&lang=js"
export * from "./searchbar.vue?vue&type=script&lang=js"

import "./searchbar.vue?vue&type=style&index=0&id=78bfd48e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/shinai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bfd48e"]])

export default __exports__